import { useEffect } from 'react'
import { useInvalidateQueries } from '../../../../../hooks/useInvalidateQueries'
import { PaginationStoreType } from '../../../../../stores/NewPaginationStore'
import stackActionsSelectStyles from '../../../../../utils/components/StackActions/stackActionsSelectStyles'
import { getStyles } from '../../../../../utils/utils/commonUtils'
import {
  groupOperations,
  groupOperationsStore,
} from '../stores/GroupOperationStore'
import { RequestTableParamsType } from '../types/new-requests-table.types'
import { useMarkAsDangerous } from './useMarkAsDangerous'
import { useRequestsTableData } from './useNewRequestsTableData'
import { useSendToArchive } from './useSendToArchive'

export const useGroupOperations = (
  checkboxStore: any,
  paginationStore: PaginationStoreType<RequestTableParamsType>,
) => {
  const { value, setValue, selectChanged, setSelectedChanged } =
    groupOperationsStore
  const { data } = useRequestsTableData(paginationStore)
  const { size = 0, totalSize = 0 } = data || {}
  const { page, setPage } = paginationStore
  const maxPage = Math.ceil(totalSize / size) - 1
  const invalidate = useInvalidateQueries()
  const { selectedIds, status } = checkboxStore
  const { sendToArchive } = useSendToArchive(checkboxStore)
  const { markAsDangerousFn, unmarkAsDangerousFn } =
    useMarkAsDangerous(checkboxStore)
  const classes = getStyles(stackActionsSelectStyles)

  const activeItem = groupOperations()?.find((el: any) => el.name === value)
  const renderItems = groupOperations()
    ?.filter((el) => el.name !== 'ВЫБЕРИТЕ ДЕЙСТВИЕ')
    .filter((el) => el.status?.(status))

  const selectDisabled = !selectedIds.length || !renderItems.length

  useEffect(() => {
    if (selectDisabled && value !== 'ВЫБЕРИТЕ ДЕЙСТВИЕ') {
      setValue('ВЫБЕРИТЕ ДЕЙСТВИЕ')
    }
  }, [selectDisabled, value, setValue])

  const onClick = async () => {
    let shouldResetPage = page === maxPage && checkboxStore.isAllChecked

    if (activeItem?.name === 'ДОБАВИТЬ В АРХИВ') {
      sendToArchive()
    } else if (activeItem?.name === 'включить в проблемную зону') {
      markAsDangerousFn()
    } else if (activeItem?.name === 'Исключить из проблемной зоны') {
      unmarkAsDangerousFn()
    } else if (activeItem?.action) {
      await activeItem.action(selectedIds)
      if (activeItem?.invalidate) {
        if (shouldResetPage) {
          setPage(0)
        } else {
          invalidate(['requests-table'])
        }
      }

      setValue('ВЫБЕРИТЕ ДЕЙСТВИЕ')
    }
  }

  const onOpen = () => {
    if (!selectChanged) {
      setValue('')
    }
  }

  const onChange = (e: any) => {
    setSelectedChanged(true)
    setValue(e.target.value as unknown as string)
  }

  return {
    renderItems,
    onClick,
    classes,
    selectChanged,
    selectDisabled,
    onChange,
    onOpen,
    value,
    activeItem,
  }
}
